<template>
  <div>
    <b-container fluid>
      <title>Admin Request Edit - HRM Requests</title>
      <h1>Admin Request Edit</h1>

      <div class="card">
          <div class="card-header">Request</div>
          <div class="card-body">
              <b-row>
                  <b-col cols="12" lg="12">
                      <BaseTextOutput v-model="request.mdhTrackingId"
                                      label="MDH Tracking ID"/>
                  </b-col>
              </b-row>
          </div>
      </div>
      <div class="card">
          <div class="card-header">Position Request</div>
          <div class="card-body">
              <b-row>
                  <b-col cols="12" lg="4">
                      <BaseEmployeeSelector v-model="request.submitter"
                                            label="Submitter"
                                            :v="$v.request.submitter"
                                            slug="submitter"
                                            tip=""
                                            :showPcn="true"/>
                  </b-col>
                  <b-col cols="12" lg="4">
                      <BaseSwitchInput v-model="request.completed"
                                       :v="$v.request.completed"
                                       label="Is Request Complete?"/>
                  </b-col>
                  <b-col cols="12" lg="4">
                      <BaseSelector v-model="request.bargainingUnit"
                                    :v="$v.request.bargainingUnit"
                                    label="Bargaining Unit"
                                    slug="bargainingUnit"
                                    :options=bargainingUnitOptions
                      />
                  </b-col>
              </b-row>
              <b-row>
                  <b-col cols="12" lg="12">
                      <BaseParagraphInput v-model="request.hrInternalEquityComparisonAnalysis"
                                          :v="$v.request.hrInternalEquityComparisonAnalysis"
                                          label="HR Internal Equity and Comparison Analysis"
                                          slug="hrInternalEquityComparisonAnalysis"
                                          tip=""/>
                  </b-col>
              </b-row>

              <b-row>
                  <b-col cols="12" lg="6">
                      <BaseParagraphInput v-model="request.educationLevel"
                                          :v="$v.request.educationLevel"
                                          label="Education Level"
                                          slug="educationLevel"
                                          tip=""/>
                  </b-col>
                  <b-col cols="12" lg="6">
                      <BaseParagraphInput v-model="request.yearsRelatedExperience"
                                          :v="$v.request.yearsRelatedExperience"
                                          label="Years of Related Experience"
                                          slug="yearsRelatedExperience"
                                          tip=""/>
                  </b-col>
                  <b-col cols="12" lg="6">
                      <BaseParagraphInput v-model="request.specialSkills"
                                          :v="$v.request.specialSkills"
                                          label="Special Skills"
                                          slug="specialSkills"
                                          tip=""/>
                  </b-col>
              </b-row>
          </div>
      </div>
      <div class="card">
          <div class="card-header">Request Lifecycle History</div>
          <div class="card-body">

              <div class="card" v-for="(phase, index) in request.phases" :key="index">
                  <div class="card-header">{{phase.requestStatus}}</div>
                  <div class="card-body">
                      <b-row>
                          <b-col cols="3"><strong>Date/Time Phase Entered</strong></b-col>
                          <b-col cols="8">{{phase.requestStatusInDatetime}}</b-col>
                      </b-row>
                      <b-row>
                          <b-col cols="12" lg="4">
                              <BaseDateTimeInput v-model="phase.requestStatusOutDatetime"
                                                 :v="$v.request.phases.$each[index].requestStatusOutDatetime"
                                                 label="Date/Time Phase Exited"
                                                 slug="exit-date"/>
                          </b-col>
                      </b-row>
                      <b-row>
                          <b-col cols="3"><strong>Phase Duration (dd:hh:mm)</strong></b-col>
                          <b-col cols="8">{{phase.formattedDuration}}</b-col>
                      </b-row>
                      <b-row v-if="phase.contextAttribute1">
                          <b-col cols="3"><strong>{{phase.contextLabel1}}</strong></b-col>
                          <b-col cols="8">{{phase.contextAttribute1}}</b-col>
                      </b-row>
                      <b-row v-if="phase.contextAttribute2">
                          <b-col cols="3"><strong>{{phase.contextLabel2}}</strong></b-col>
                          <b-col cols="8">{{phase.contextAttribute2}}</b-col>
                      </b-row>
                      <b-row v-if="phase.contextAttribute3">
                          <b-col cols="3"><strong>{{phase.contextLabel3}}</strong></b-col>
                          <b-col cols="8">{{phase.contextAttribute3}}</b-col>
                      </b-row>
                      <b-row v-if="phase.contextAttribute4">
                          <b-col cols="3"><strong>{{phase.contextLabel4}}</strong></b-col>
                          <b-col cols="8">{{phase.contextAttribute4}}</b-col>
                      </b-row>
                      <b-row v-if="phase.contextAttribute5">
                          <b-col cols="3"><strong>{{phase.contextLabel5}}</strong></b-col>
                          <b-col cols="8">{{phase.contextAttribute5}}</b-col>
                      </b-row>
                      <b-row v-if="phase.comments">
                          <b-col cols="3"><strong>Comments</strong></b-col>
                          <b-col cols="8">{{phase.comments}}</b-col>
                      </b-row>
                  </div>
              </div>
          </div>
      </div>
      <div class="card">
          <div class="card-header">Manager Queue</div>
          <div class="card-body">

              <div class="card" v-for="(queue, index) in request.queues" :key="index">
                  <div class="card-header">{{queue.requestStatus}}</div>
                  <div class="card-body">
                      <b-row>
                          <b-col cols="3"><strong>Date/Time In</strong></b-col>
                          <b-col cols="8">{{queue.inDateTime}}</b-col>
                      </b-row>
                      <b-row>
                          <b-col cols="12" lg="4">
                              <BaseDateTimeInput v-model="queue.outDateTime"
                                             :v="$v.request.queues.$each[index].outDateTime"
                                             label="Date/Time Out"
                                             slug="out-date"/>
                          </b-col>
                      </b-row>
                      <b-row>
                         <b-col>
                             <BaseEmployeeSelector v-model="queue.submitter"
                                                   label="Submitter"
                                                   :v="$v.request.queues.$each[index].submitter"
                                                   slug="queue-submitter"
                                                   tip=""
                                                   :showPcn="true"/>
                         </b-col>
                      </b-row>
                  </div>
              </div>
          </div>
      </div>
      <b-row class="mt-2">
          <b-col>
              <b-button type="button" variant="primary" @click="submit">
                  <b-spinner small v-show="loading" class="mr-2"></b-spinner>
                  Submit
              </b-button>
          </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { required } from 'vuelidate/lib/validators'
  import BaseTextOutput from "@/components/BaseTextOutput";
  import BaseSelector from "@/components/BaseSelector";
  import BaseDateTimeInput from "@/components/BaseDateTimeInput";
  import BaseSwitchInput from "@/components/BaseSwitchInput";
  import BaseParagraphInput from "@/components/BaseParagraphInput";
  import BaseEmployeeSelector from "@/components/BaseEmployeeSelector";
  import { commonOptions } from '@/mixins/commonOptions.js'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
      components: {
          BaseTextOutput,
          BaseEmployeeSelector,
          BaseParagraphInput,
          BaseSwitchInput,
          BaseDateTimeInput,
          BaseSelector
      },
      mixins: [
          commonOptions
      ],
      data: () => ({
        loading: false,
        requestId: null,
        request: {}
      }),

    validations() {
        return {
          request: {
              submitter: {
                  userId: {
                      required: false,
                  }
              },
              completed: { required: false },
              bargainingUnit: { required: false },
              hrInternalEquityComparisonAnalysis: { required: false },
              yearsRelatedExperience: { required: false },
              educationLevel: { required: false },
              specialSkills: { required: false },
              queues: {
                  required: false,
                  $each: {
                      outDateTime: { required: false },
                      submitter: { required: false },
                  }
              },
              phases: {
                  required: false,
                  $each: {
                      requestStatusOutDatetime: { required: false },
                  }
              }
          },
        }
    },
    created() {
        this.requestId = this.$route.params.id

        this.fetchRequest()
    },

    methods: {
      fetchRequest() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/edit/${this.requestId}`)
              .then(response => {
                  console.log(response)
                  this.request = response.data;
              })
      },
      submit () {
        this.loading = true
        //  TODO: test
        if (this.$v.request.phases.$anyDirty) {
            this.request.phasesTouched = true
        }
        if (this.$v.request.queues.$anyDirty) {
            this.request.queuesTouched = true
        }
        //  TODO: giving bad request?
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/request`, this.request)
        .then(response => {
          this.loading = false
            this.$bvToast.toast('HRM Request Updated', {
              title: 'Status',
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: 'success',
              appendToast: true
            });
        });
      }
    }
  }
</script>